import PropTypes from "prop-types";
import React from "react";
import { changeLanguage } from "redux-multilanguage";
//import { fetchProducts } from "redux/actions/productActions";
import { multilanguage } from "redux-multilanguage";
const LanguageChanger = ({
  currentLanguageCode,
  dispatch,
  strings
}) => {
  const changeLanguageTrigger = e => {
    const languageCode = e.target.value;
    dispatch(changeLanguage(languageCode));
  };

  return (
    <div className="language-button">
           {currentLanguageCode === "en" ?
              <button value="zh" onClick={e => changeLanguageTrigger(e)}>
                中文
              </button>
              :
              <button value="en" onClick={e => changeLanguageTrigger(e)}>
                Eng
              </button>
            }            
    </div>
  );
};

LanguageChanger.propTypes = {
  currentLanguageCode: PropTypes.string,
  dispatch: PropTypes.func
};

export default multilanguage(LanguageChanger);
